import { render } from "./flashing-stock.md?vue&type=template&id=1fd36f16"
import script from "./flashing-stock.md?vue&type=script&lang=js"
export * from "./flashing-stock.md?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__